module.exports = __webpack_public_path__ + "static/media/lock.1939c794.svg";